import './tripStrapNew.css';

import { useEffect, useState } from 'react';

import Calendar from '../../assets/icons/trvto_calendar.svg';
import CancelBooking from '../tripStrap/tripStrapFun/cancelBooking';
import { ReactComponent as Close } from '../../assets/icons/trvto_close.svg';
import { ReactComponent as Delete } from '../../assets/icons/trvto_deleteIcon.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import RateTrip from '../ratingTrip/rateTrip';
import ReviewStars from '../reviewStars/ReviewStars';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import UserCount from '../../assets/icons/trvto_userCount.svg';
import { getAmenities } from '../tripStrap/tripStrapFun/amenities';
import { handleBooking } from '../tripStrap/tripStrapFun/handleBooking';
import image1 from '../../assets/images/trvto_tripDetails.jpg';
import { share } from '../tripStrap/tripStrapFun/shareFun';
import { userReview } from '../../api/userAPI';
import RenderFormContent from '../tripStrap/renderFormContent';
import TableContent from '../tripStrap/tableContent';
import { handleWishlistClick } from '../../utils/wishlistHandler';
import { calculateOfferPrice, getHikedPrice } from '../../utils/getAmountWithTransaction';
import { isTripDateMoreThanNumOfDays } from '../../utils/date';
import { standardDate } from '../../utils/formatDate';
import { getRefundAmount } from '../tripStrap/amountRefundFun/amountRefund';
import { parsePurify } from '../../utils/parsePurify';
import RescheduleBooking from '../tripStrap/tripStrapFun/RescheduleBooking';
import { truncateText } from '../../utils/maskFields';
import { toast } from 'react-toastify';
import { getTotalSeatCount } from '../../utils/getTotalSeatCount';

export default function TripStrapNew({
    page,
    data,
    userWishlist,
    setUserWishlist,
    setDetailsData,
    setRefetch,
    selectedId,
    setSelectedId
}) {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showBookingInfo, setShowBookingInfo] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const typeSel = searchParams.get('type') || 'trip';
    const [userRating, setUserRating] = useState(0);
    const [isRatingEnabled, setIsRatingEnabled] = useState(false);
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [comment, setComment] = useState('');
    const [showOverlay, setShowOverlay] = useState(false);
    const [newCardData, setNewCardData] = useState({});
    const [refundAmount, setRefundAmount] = useState(0);
    const [popupRating, setPopupRating] = useState(userRating);
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [isTripMoreThanTenDays, setIsTripMoreThanTenDays] = useState(false);
    const [isTripMoreThanOneDays, setIsTripMoreThanOneDays] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const width = window.innerWidth;
    const createdAt = data.createdAt;

    useEffect(() => {
        const today = new Date();
        const startDate = new Date(data?.startDate);
        today.setHours(0, 0, 0, 0);
        if (startDate <= today) {
            setIsRatingEnabled(true);
        }
    }, [data?.startDate]);

    useEffect(() => {
        if (!createdAt) return;

        const createdTime = new Date(createdAt);
        const expiryTime = new Date(createdTime.getTime() + 6 * 60 * 60 * 1000); // +6 hours
        const now = new Date();

        if (now < expiryTime) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [createdAt]);

    //eslint-disable-next-line
    const handleCancelBooking = async (e) => {
        e.stopPropagation();
        const refundAmount = await getRefundAmount({ amount: data?.amountPaid?.paid, startDate: data?.startDate });
        setRefundAmount(refundAmount);
        setShowModal(true);
    };

    const handleRescheduleBooking = (event) => {
        event.stopPropagation();
        setShowRescheduleModal(true);
    };

    const openRatingModal = (e, cardData) => {
        e.stopPropagation();
        setShowRatingModal(true);
        setPopupRating(userRating);
        setNewCardData(cardData);
    };

    const closeRatingModal = () => {
        setShowRatingModal(false);
    };

    const handleClick = (data) => {
        navigate(`/trip/details/${data}`, {
            state: { tripStatus }
        });
    };

    const handleInfoClick = () => {
        if (page === 'bookings') {
            setShowBookingInfo(!showBookingInfo);
        } else {
            setShowOverlay(!showOverlay);
        }
    };

    const handleSubmitRating = async (e) => {
        e.preventDefault();

        const ratingData = {
            packId: newCardData?._id,
            userName: localStorage.getItem('name') || '',
            userId: localStorage.getItem('userId') || '',
            rating: popupRating,
            organizerId: data?.organizerId,
            comment
        };

        try {
            await userReview(typeSel, ratingData);
            toast.success('Thank you! Your rating has been submitted');
            setUserRating(popupRating);
            closeRatingModal();
        } catch (error) {
            console.error('Error submitting rating:', error);
        }
    };

    let cardData;
    let packStartDate;
    let packEndDate;
    let pickUpLocation;
    let startCity;
    let tripStatus;
    let paymentInfoStatus;

    if (page === 'bookings') {
        cardData = data?.packId || data?.guTourId || data?.actId || data?.campId;
        packStartDate = data?.startDate;
        packEndDate = data?.endDate;
        // trips: pickup point · stays: the unit booked
        pickUpLocation = data?.pickupLocation || data?.unitName;
        startCity = data?.startCity;
        tripStatus = data?.tripStatus || data?.guStatus || data?.actStatus || data?.stayStatus;
        paymentInfoStatus = data?.paymentInfo.status;
    } else {
        cardData = data;
    }
    const formData = [
        {
            label: 'Duration',
            answer: cardData?.quickView?.duration
        },
        {
            label: 'Organizer',
            answer: cardData?.organizerName
        }
    ];

    useEffect(() => {
        if (!data?.startDate) return;
        setIsTripMoreThanTenDays(isTripDateMoreThanNumOfDays(data.startDate, 10));
        setIsTripMoreThanOneDays(isTripDateMoreThanNumOfDays(data.startDate, 1));
    }, [data?.startDate]);

    return (
        <div
            className={`tripStrapNew ${selectedId === data._id ? 'tripStrapSelected' : ''}`}
            onClick={() => {
                setDetailsData(data);
                setSelectedId(data._id);
            }}
        >
            <div className='tripStrapNewContent'>
                <div className='imgContent'>
                    <img
                        src={cardData?.cardImages?.length > 0 ? cardData?.cardImages[0] : image1}
                        alt='trvto_trip'
                        className='tripStrapImageNew'
                        loading='lazy'
                        decoding='async'
                    />
                </div>
                <div className='tripStrapInfoDiv'>
                    <div className='tripStrapNameDiv alignCenter'>
                        <div className='tripStrapInfo'>
                            <div className='tripStrapName'>
                                <span className={`${tripStatus === 'Cancelled' ? 'tripCancelled' : ''}`}>
                                    {truncateText(cardData?.title, width > 768 ? 50 : 25) || 'N/A'}
                                </span>
                                {/* {Array.isArray(cardData?.quickView?.type) &&
                                    cardData.quickView.type.includes('Trek') && (
                                        <div className='typeInfo'>{cardData.quickView.type[0]}</div>
                                    )} */}
                                <Share onClick={(e) => share(e, cardData._id, typeSel, cardData?.title)} />
                            </div>
                            <p className='quickView'>
                                {/* {page === 'wishlist' && (
                                    <>
                                        {cardData?.quickView?.where +
                                            ' (' +
                                            (cardData?.days ? cardData.days + 'D/' + cardData?.nights + 'N' : 'N/A') +
                                            ')'}
                                        <span className='tripStartDate'>
                                            {' '}
                                            - {getFormattedDate(data?.tripDates)} Onwards
                                        </span>
                                    </>
                                )} */}
                                {page === 'bookings' && pickUpLocation}
                                {/* {tripStatus !== 'Cancelled' && isTripMoreThanOneDays && (
                                    <button
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            sessionStorage.setItem(
                                                'confirmedBookingData',
                                                JSON.stringify({ ...data, isTripMoreThanOneDays })
                                            );
                                            navigate(`/trip/details/${cardData?._id}`);
                                        }}
                                        style={{
                                            marginLeft: 10,
                                            fontSize: '10px',
                                            border: 'none',
                                            cursor: 'pointer'
                                        }}
                                        className='typeInfo'
                                    >
                                        Update Pickup Location
                                    </button>
                                )} */}
                            </p>
                            <p>
                                {' '}
                                {/* {tripStatus !== 'Cancelled' && isTripMoreThanOneDays && (
                                    <button
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            sessionStorage.setItem(
                                                'confirmedBookingData',
                                                JSON.stringify({ ...data, isTripMoreThanOneDays })
                                            );
                                            navigate(`/trip/details/${cardData?._id}`);
                                        }}
                                        style={{
                                            marginLeft: 10,
                                            fontSize: '10px',
                                            border: 'none',
                                            cursor: 'pointer'
                                        }}
                                        className='pickUp'
                                    >
                                        Update Pickup Location
                                    </button>
                                )} */}
                            </p>

                            <div className='tripCardNumInfoDiv'>
                                <div className='tripCardNumInfo'>
                                    <ReviewStars rating={cardData?.rating || data?.organizerId?.rating || 0} />
                                    <span>{cardData?.rating || data?.organizerId?.rating || 0}</span>
                                    <p style={{ margin: 0 }}>
                                        ({cardData?.reviewCount || data?.organizerId?.reviewCount || 0} Reviews)
                                    </p>
                                </div>
                                {tripStatus === 'Cancelled' ? (
                                    <p className='removeStrike cancelled'>{tripStatus}</p>
                                ) : (
                                    <p className='tripStatus'>{tripStatus}</p>
                                )}
                            </div>
                            <div className='dateUserWrapper'>
                                {/* DATE BOX */}
                                {page === 'bookings' && (
                                    <div className='tripStrapDateDetails'>
                                        <div className='alignCenter'>
                                            <img src={Calendar} width={24} height={24} alt='calendar' />
                                            {typeSel === 'trip' ? (
                                                <span className='innerStrap'>
                                                    <span className='innerStrapColumn'>
                                                        <span>
                                                            {new Date(packStartDate).toLocaleDateString('en-GB')}
                                                        </span>
                                                        <span>{cardData?.quickView?.startTime?.toUpperCase()}</span>
                                                    </span>

                                                    <label>-</label>

                                                    <span className='innerStrapColumn'>
                                                        <span>{new Date(packEndDate).toLocaleDateString('en-GB')}</span>
                                                        <span>{cardData?.quickView?.endTime?.toUpperCase()}</span>
                                                    </span>
                                                </span>
                                            ) : (
                                                <span className='innerStrap'>
                                                    <span className='innerStrapColumn'>
                                                        <span>
                                                            {new Date(packStartDate).toLocaleDateString('en-GB')}
                                                        </span>
                                                        <span>{data?.timeSlots?.startTime.toUpperCase()}</span>
                                                    </span>

                                                    <label>-</label>

                                                    <span className='innerStrapColumn'>
                                                        <span>{new Date(packEndDate).toLocaleDateString('en-GB')}</span>
                                                        <span>{data?.timeSlots?.endTime.toUpperCase()}</span>
                                                    </span>
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* USER COUNT BOX */}
                                {page === 'bookings' && (
                                    <div className='userCountBox'>
                                        <img src={UserCount} alt='user' />
                                        <span className='userCount'>
                                            {Array.isArray(data?.totalSeats)
                                                ? getTotalSeatCount(data?.totalSeats)
                                                : data?.totalSeats || 0}
                                        </span>
                                    </div>
                                )}
                            </div>
                            {cardData?.type === 'rooms' && (
                                <div className='amenities'>{getAmenities(cardData?.quickView?.amenities)}</div>
                            )}
                            {/* {page === 'bookings' &&
                                Array.isArray(cardData?.quickView?.type) &&
                                cardData.quickView.type.includes('Trek') && (
                                    <div className='innerFormContent'>
                                        <RenderFormContent data={formData} />
                                    </div>
                                )} */}
                        </div>
                        <div className='tripStrapPriceDiv'>
                            <div className='tripStrapPrDiv'>
                                {/* <p
                                    className={`${
                                        tripStatus === 'Cancelled' ? 'tripStrapPrice tripCancelled' : 'tripStrapPrice'
                                    }`}
                                >
                                    <>
                                        ₹
                                        {page === 'bookings'
                                            ? data?.amountPaid?.paid
                                            : data?.datesType === 'fixed'
                                              ? cardData?.price[0]?.price.actual
                                              : Math.round(calculateOfferPrice(null, data, null))}
                                        {page !== 'bookings' && <span>/{typeSel === 'trip' ? 'person' : 'night'}</span>}
                                    </>
                                </p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {cardData?.type === 'trip' && (
                    <>
                        <div className='tripDivider holidayDivider' />
                        <p className='locationInfo'>
                            Pickup Location: <span>{cardData?.quickView?.pickupLocation}</span>
                        </p>
                    </>
                )}
            </div>
            {showRescheduleModal && <RescheduleBooking setShowRescheduleModal={setShowRescheduleModal} data={data} />}
            {showModal && (
                <CancelBooking
                    setShowModal={setShowModal}
                    refundAmount={refundAmount.refAmount}
                    handleConfirm={(e) => {
                        e.stopPropagation();
                        handleBooking(data, setShowModal, typeSel)
                            .then(() => {
                                setRefetch((prev) => !prev);
                            })
                            .catch((err) => console.error('Cancel failed', err));
                    }}
                />
            )}
            {showRatingModal && (
                <div className='ratingModal'>
                    <div className='modalContent'>
                        <h3>Rate Your Trip</h3>
                        <RateTrip
                            props={{
                                popupRating,
                                setPopupRating,
                                comment,
                                setComment
                            }}
                        />
                        <div className='modalActions'>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeRatingModal(e);
                                }}
                                className='closeModal'
                            >
                                Cancel
                            </button>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeRatingModal(e);
                                    handleSubmitRating(e);
                                }}
                                className='submitRating'
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
